// Autogenerated file
export const avoidTollRoadFlagsEnum = {
    M1: "M1",
    M3: "M3",
    M4: "M4",
    M11: "M11",
    M12: "M12",
    CRR: "CRR",
    ZSD: "ZSD",
    EastExitUfa: "EastExitUfa",
    BypassTolyatti: "BypassTolyatti",
    A289: "A289",
    M12DRT: "M12DRT",
    M12NCH: "M12NCH",
    M12WithoutDRT: "M12WithoutDRT",
    KhbBp1342: "KhbBp1342",
};
export const avoidTollRoadFlags = [
    { label: "Избегать М-1", value: "M1", intValue: 1 },
    { label: "Избегать М-3", value: "M3", intValue: 2 },
    { label: "Избегать М-4", value: "M4", intValue: 4 },
    { label: "Избегать М-11", value: "M11", intValue: 8 },
    { label: "Избегать М-12", value: "M12", intValue: 16 },
    { label: "Избегать ЦКАД", value: "CRR", intValue: 32 },
    { label: "Избегать ЗСД", value: "ZSD", intValue: 64 },
    { label: "Избегать восточный выезд из Уфы", value: "EastExitUfa", intValue: 128 },
    { label: "Избегать объезд Тольятти", value: "BypassTolyatti", intValue: 256 },
    { label: "Избегать платной части дороги А-289", value: "A289", intValue: 512 },
    { label: "Запрет участка \"Дюртюли - Ачит\" М-12", value: "M12DRT", intValue: 1024 },
    { label: "Запрет участка \"Нижнекамск - Набережные Челны\" М-12", value: "M12NCH", intValue: 2048 },
    { label: "Избегать М-12 за исключением участка \"Дюртюли - Ачит\"", value: "M12WithoutDRT", intValue: 4096 },
    { label: "Избегать обход Хабаровска 13 км - 42 км", value: "KhbBp1342", intValue: 8192 },
];
